"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.07,3.26A8.54,8.54,0,1,1,3.62,11.8a8.51,8.51,0,0,1,8.45-8.54m0-1a9.54,9.54,0,1,0,9.45,9.54,9.5,9.5,0,0,0-9.45-9.54Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.07,17.54a1,1,0,0,1-1-1v-5a1,1,0,0,1,2,0v5A1,1,0,0,1,12.07,17.54Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.07,8.79a1,1,0,0,1-1-1V7.76a1,1,0,1,1,2,0A1,1,0,0,1,12.07,8.79Z"
  }));
};

exports["default"] = _default;